import {ApiRes} from '@type/api'
import {apiGet} from '@api/api'

interface IImageSignRes {
    image_url: string
    upload_url: string
}

const apiGetImageSign = async (dir?: string): Promise<ApiRes<IImageSignRes>> => {
    return await apiGet(`imagesign?dir=${dir || ''}`)
}

export const apiUploadImage = async (file: File, dir?: string) => {
    const {data, error} = await apiGetImageSign(dir)
    if (data) {
        const {image_url, upload_url} = data

        await fetch(upload_url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'image/png',
                'Cache-Control': 'public, max-age=604800',
            },
            body: file,
        })

        return {
            success: true,
            image_url,
        }
    }

    return {
        success: false,
        error,
    }
}
